<template lang="pug">
.mg-game__new-card.type--all
  .mg-card__list(v-if="getAllOpenedCards && !show_loader")
    .mg-card(v-for="(card, index) in getPreparedCardsList", :key="index", :class="getCardClass(card)")
      .mg-card__inner(v-for="index in 3", :key="'_'+index")
        img.mg-card__front(:src="getImgSrc(card)")

      .mg-card__count x{{ getCardsAmount(card) }}
  button.button.button-medium(@click="closePopup") {{ $t("popup.claim") }}
  .mg-game__loader(v-if="!getAllOpenedCards && show_loader")
</template>

<script>
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapGetters } = createNamespacedHelpers(mg_global);

export default {
  name: "NewCardAll",

  data() {
    return {
      show_loader: true,
    };
  },

  computed: {
    ...mapGetters(["getAllOpenedCards"]),
    getPreparedCardsList() {
      return Array.from(new Set(this.getAllOpenedCards.map((item) => item.level))).sort(
        (a, b) => a - b
      );
    },
  },

  mounted() {
    if (this.new_card_all) {
      this.show_loader = false;
      setTimeout(this.closePopup, 2500);
    } else {
      this.drawCardAll();
    }
  },

  beforeDestroy() {
    this.$emit("stopProgress");
    this.$store.commit(`${mg_global}/placeNewCardAll`, this.getAllOpenedCards);
    this.$store.commit(`${mg_global}/setNewCardAll`, null);
  },

  methods: {
    closePopup() {
      this.$emit("closePopup");
    },

    getCardsAmount(card_row) {
      return this.getAllOpenedCards.filter((item) => item.level === card_row).length;
    },

    getCardClass(card_row) {
      return `type--card${card_row}`;
    },

    getImgSrc(card_row) {
      try {
        return require(`@/assets/game/images/cards/card_row${card_row}_1.png`);
      } catch (e) {
        return require(`@/assets/game/images/cards/back.png`);
      }
    },

    drawCardAll() {
      this.$store
        .dispatch(`${mg_global}/drawCardAll`)
        .then(() => {
          this.show_loader = false;
        })
        .catch((error) => {
          this.closePopup();

          this.$notify({
            type: "error",
            closeOnClick: "true",
            duration: 5000,
            group: "collection",
            position: "bottom right",
            text: this.$t(`error.${error.message}`),
          });
        });
    },
  },
};
</script>
